import { BEGIN_FETCH_SPONSORED_PRODUCTS, BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS } from 'store/ducks/search/types';

/**
* Starts the Saga to fetch sponsored
* @param  {object}  params                   list of query params
* @param  {string}  slot                     slot to display ads
* @param  {number}  limit                    limit products returned
* @param  {boolean} defaultOrder             Randomize or return items in original list
*/
export const fetchSponsoredProducts = params => ({
  type: BEGIN_FETCH_SPONSORED_PRODUCTS,
  payload: params
});

export const fetchSymphonySearchComponents = () => ({
  type: BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS
});
